import { useState } from "react";
import styles from "./json.module.css";
import { Input, Tabs, Table } from "antd";
import SchoolJson from "../../../data/current/bi-lang-school.json";
import StudentJson from "../../../data/current/bi-lang-student.json";
import TeacherJson from "../../../data/current/bi-lang-teacher.json";
import CommonJson from "../../../data/bi-lang-common.json";
import Text from "../../../context/language-context";
type DataMappingType = {
  [key: string]: {
    key: string;
    value: {
      en: string;
      sk: string;
      hi: string;
    };
  }[];
};

const dataMapping: DataMappingType = {
  School: SchoolJson,
  Student: StudentJson,
  Teacher: TeacherJson,
  Common: CommonJson,
};

const columns = [
  {
    title: "Key",
    dataIndex: "key",
    key: "key",
    width: "25%",
  },
  {
    title: "English",
    dataIndex: ["value", "en"],
    key: "en",
    width: "25%",
  },
  {
    title: "Hindi",
    dataIndex: ["value", "hi"],
    key: "hi",
    width: "25%",
  },
  {
    title: "Sanskrit",
    dataIndex: ["value", "sk"],
    key: "sa",
    width: "25%",
  },
];

export default function JsonMapping() {
  const [activeTab, setActiveTab] = useState("School");
  const [searchText, setSearchText] = useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <div className={styles.jsonTable}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4>JSON Mapping</h4>
        <Input
          placeholder={`${Text({ tid: "SEARCH", def: "Search" })}`}
          value={searchText}
          onChange={handleSearch}
          style={{
            // width: 200,
            borderColor: "var(--bs-primary-light)",
            width: "max-content",
          }}
          // style={{ marginBottom: 16 }}
        />
      </div>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
      >
        {Object.keys(dataMapping).map((tab) => {
          const filteredData = dataMapping[tab].filter((item) =>
            Object.values(item).some((field) =>
              typeof field === "string"
                ? field.toLowerCase().includes(searchText.toLowerCase())
                : Object.values(field).some(
                    (subField) =>
                      typeof subField === "string" &&
                      subField.toLowerCase().includes(searchText.toLowerCase())
                  )
            )
          );
          return (
            <Tabs.TabPane
              tab={tab}
              key={tab}
            >
              <div className='tableWrap'>
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey='key'
                  pagination={{
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total: number, range: [number, number]) =>
                      `Showing ${range[0]}-${range[1]} of ${total} total entries`,
                    showSizeChanger: true,
                    showQuickJumper: false,
                    position: ["bottomLeft"],
                  }}
                  sticky
                  size='small'
                  scroll={{ y: 300 }}
                />
              </div>
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </div>
  );
}
